import React, { useMemo } from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import FilterPopover from 'talent_matching/components/filters/filter_popover';
import { useAdvancedFiltersContext } from 'talent_matching/contexts/advanced_filters_context';

const t = withLocalePrefix('talent_matching.filter_row.advanced_filters');

// Filters only supported in OpenSearch (not Solr) must be excluded from rediscovery
const UNSUPPORTED_FILTER_VALUES = ['has_cover_letter'];

const AdvancedFiltersGroup = () => {
  const { filterGroups } = useAdvancedFiltersContext();

  const filteredGroups = useMemo(
    () =>
      filterGroups.map((group) => ({
        ...group,
        items: group.items.filter(
          (item) => !UNSUPPORTED_FILTER_VALUES.includes(item.value)
        ),
      })),
    [filterGroups]
  );

  return (
    <FilterPopover
      fieldName="advancedFilters"
      title={t('title')}
      getButtonLabel={(count: number) => t('button', { count })}
      addLabel={t('add_filter')}
      clearLabel={t('clear')}
      typeOptions={filteredGroups}
    />
  );
};

export default AdvancedFiltersGroup;
